<template>
  <div>
    <div :class="`share-module layout-${layout}`">
      <a class="icon-share" @click="share('facebook',shareLink)">
        <iconFacebook :color="color" />
      </a>
      <a class="icon-share" @click="share('linkedin',shareLink)">
        <iconLinkedin :color="color"/>
      </a>
      <a class="icon-share" @click="share('twitter',shareLink)">
        <iconTwitter :color="color" />
      </a>
      <a class="icon-share" @click="share('mail',shareLink)">
        <iconEnvelope :color="color" />
      </a>
      <a class="icon-share" v-b-modal.modal_iframe_share>
        <iconCode :color="color" />
      </a>
    </div>
  </div>
</template>


<script>
  import iconCode from "./icons/code.vue";
  import iconEnvelope from "./icons/envelope.vue";
  import iconFacebook from "./icons/facebook.vue";
  import iconLinkedin from "./icons/linkedin.vue";
  import iconTwitter from "./icons/twitter.vue";

export default {
  name: "SocialShare",
  props: {
    shareLink: {
      type: String,
    },
    title:{
      type: String,
      default: "",
    },
    layout:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      color: (this.layout === "home") ? "#fff" : "#fff",
      show: false,
    };
  },
  components: {
    iconCode,
    iconEnvelope,
    iconFacebook,
    iconLinkedin,
    iconTwitter
  },
  methods: {
    share(action,url=null) {
      let left = (screen.width - 570) / 2;
      let top = (screen.height - 570) / 2;
      let params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top +",left=" +left;
      
      url = url ? url : document.URL;
      url = (action != "mail") ? url : encodeURIComponent(url);
      switch (action) {
        case "facebook":
          url = `https://www.facebook.com/sharer.php?u=${url}`;
          break;
        case "linkedin":
          url = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`
          break;
        case "twitter":
          url = `https://twitter.com/intent/tweet?url=${url}&text=${this.title}&via=ICIJorg`;
          break;
        case "mail":
          url = `mailto:?subject=${this.title}&body=${url}`
          document.location.href = url;
          return;
      }
      window.open(url, "Share", params);
    },
  }
};


</script>
<style lang="scss">
.share-module {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  .icon-share {
    cursor: pointer;
    height: 2.5rem;
    width: 2.5rem;
    display: flex;
    background: var(--app-color-black);
    border-radius: 100%;
    justify-content: center;
    align-items: center;
    svg{
      width: 1.2rem;
      height: 1.2rem;
    }
    margin: 0rem .2rem;
  }
  &::before,&::after{
    content: "";
    width: 3rem;
    height: 0.3rem;
    background-color: var(--app-color-black);
    margin: 0rem 1rem;
    display: none;
  }
  
  &.layout-home{
    justify-content: center;
    .icon-share {
      background: #000;
    }
    &::before,&::after{
      display: block;
    }
  }
}
</style>
